import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../Services/supabaseClient';
import styles from './Login.module.css';

export default function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const { data, error } = await supabase.auth.signInWithPassword({ email, password });
      if (error) throw error;
      localStorage.setItem('a_access_token', data.session.access_token);
      onLogin(data.user);
      navigate('/dashboard');
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className={styles.formContainer}>
      <div className={styles.formForm}>
        <div className={styles.formContent}>
          <form className="text-left" onSubmit={handleSubmit}>
            <div className={styles.form}>
              <div className={styles.fieldWrapper}>
                <label htmlFor="email">EMAIL</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  className={styles.formControl}
                  placeholder="Email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className={styles.fieldWrapper}>
                <label htmlFor="password">PASSWORD</label>
                <div style={{ position: 'relative' }}>
                  <input
                    id="password"
                    name="password"
                    type="password"
                    className={styles.formControl}
                    placeholder="Password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    required
                  />
                </div>
              </div>

              {error && <div className={styles.errorMessage}>{error}</div>}

              <div className={styles.fieldWrapper}>
                <button type="submit" className={styles.btn}>Login</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
